import getAppState from 'app-state';

export function init() {
    document.addEventListener('DOMContentLoaded', () => {
        if (getAppState('attentiveMobile').enabled === true) {
            const attentiveScript = document.createElement('script');
            attentiveScript.setAttribute('src', 'https://cdn.attn.tv/reliv/dtag.js');
            document.body.appendChild(attentiveScript);
        }
    });
}
